module.exports = __webpack_public_path__ + "img/menu.46eb82ae.svg";